import { CONFIG } from "../types";

export const configReducer = (
  state = { isLoading: true, data: [] },
  action
) => {
  switch (action.type) {
    case CONFIG:
      return {
        isLoading: false,
        data: action.payload,
        filteredData: action.payload,
      };
    default:
      return state;
  }
};
